import React, { useState } from "react";
import "./SavingScheme.css";

const SavingScheme = () => {
  const [schemes, setSchemes] = useState([]);
  const [formData, setFormData] = useState({
    accountType: "",
    serviceName: "",
    minOpeningBalance: "",
    preclosurePeriod: "",
    preclosureCharge: "",
    chargeType: "",
    additionalBonus: "",
    dailyCashLimit: "",
    dailyFundLimit: "",
    locinAmount: "",
    minMonthlyBalance: "",
    nonMaintenanceCharge: "",
    roi: "",
    roiFrequency: "",
    interestPayout: "",
    prefix: "",
    serviceCharge: "",
    serviceChargeFreq: "",
    smsCharge: "",
    smsChargeFreq: "",
    schemeStatus: "",
  });

  const handleChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    setSchemes([...schemes, { ...formData, id: schemes.length + 1 }]);
    setFormData(Object.fromEntries(Object.keys(formData).map(k => [k, ""])));
  };

  const renderInput = (label, name, type = "text", placeholder = "", options = null) => (
    <div className="savingssform-group">
      <label>{label}</label>
      {options ? (
        <select name={name} value={formData[name]} onChange={handleChange}>
          <option value="">Select</option>
          {options.map((opt, i) => <option key={i} value={opt}>{opt}</option>)}
        </select>
      ) : (
        <input type={type} name={name} value={formData[name]} onChange={handleChange} placeholder={placeholder} />
      )}
    </div>
  );

  return (
    <div className="savingss-scheme-container">
      <h2>Saving Account Scheme</h2>

      <form className="savingss-scheme-form" onSubmit={handleSubmit}>
        <div className="savingssform-row">
          {renderInput("Saving Account Type", "accountType", "text", "", ["Saving Account"])}
          {renderInput("Service Name", "serviceName", "text", "Enter service name")}
        </div>
        <div className="savingssform-row">
          {renderInput("Minimum Opening Balance", "minOpeningBalance", "number", "Enter minimum opening balance")}
          {renderInput("Preclosure Period (Months)", "preclosurePeriod", "number", "Enter preclosure period")}
        </div>
        <div className="savingssform-row">
          {renderInput("Preclosure Charge", "preclosureCharge", "number", "Enter preclosure charge")}
          {renderInput("Charge Type", "chargeType", "text", "", ["Fixed", "Percentage"])}
        </div>
        <div className="savingssform-row">
          {renderInput("Additional Bonus (%)", "additionalBonus", "number", "Enter additional bonus")}
          {renderInput("Daily Cash Withdrawal Limit", "dailyCashLimit", "number", "Daily cash limit")}
        </div>
        <div className="savingssform-row">
          {renderInput("Daily Fund Transfer Limit", "dailyFundLimit", "number", "Daily fund limit")}
          {renderInput("Locin Amount", "locinAmount", "number", "Locin amount")}
        </div>
        <div className="savingssform-row">
          {renderInput("Min Monthly Avg Balance", "minMonthlyBalance", "number", "Monthly avg balance")}
          {renderInput("Non Maintenance Charge", "nonMaintenanceCharge", "number", "Enter non maintenance charge")}
        </div>
        <div className="savingssform-row">
          {renderInput("ROI (%)", "roi", "number", "Enter ROI")}
          {renderInput("ROI Frequency", "roiFrequency", "text", "", ["Daily", "Monthly", "Quarterly"])}
        </div>
        <div className="savingssform-row">
          {renderInput("Interest Payout Frequency", "interestPayout", "text", "", ["Monthly","Quarterly","Yearly"])}
          {renderInput("Prefix", "prefix", "text", "Enter service prefix")}
        </div>
        <div className="savingssform-row">
          {renderInput("Service Charge", "serviceCharge", "number", "Enter service charge")}
          {renderInput("Service Charge Frequency", "serviceChargeFreq", "text", "", ["Monthly","Quarterly","Yearly"])}
        </div>
        <div className="savingssform-row">
          {renderInput("SMS Charge", "smsCharge", "number", "Enter SMS charge")}
          {renderInput("SMS Charge Frequency", "smsChargeFreq", "text", "", ["Monthly","Quarterly"])}
        </div>
        <div className="savingssform-row">
          {renderInput("Scheme Status", "schemeStatus", "text", "", ["Active","Inactive"])}
        </div>

        <button type="submit" className="savingsssubmit-btn">Submit</button>
      </form>

      <div className="savingssscheme-report">
        <h3>Saving Account Scheme Report</h3>
        <input type="text" placeholder="Search..." className="savingsssearch-input" />
        <table>
          <thead>
            <tr>
              <th>Serial No.</th>
              <th>Action</th>
              <th>Locin Amount</th>
              <th>Scheme Name</th>
              <th>Prefix</th>
              <th>ROI</th>
              <th>Cash Withdrawal Limit</th>
              <th>Fund Transfer Limit</th>
            </tr>
          </thead>
          <tbody>
            {schemes.length ? schemes.map(s => (
              <tr key={s.id}>
                <td>{s.id}</td>
                <td>Edit/Delete</td>
                <td>{s.locinAmount}</td>
                <td>{s.serviceName}</td>
                <td>{s.prefix}</td>
                <td>{s.roi}</td>
                <td>{s.dailyCashLimit}</td>
                <td>{s.dailyFundLimit}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan="8" style={{ textAlign: "center" }}>No data available in table</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default SavingScheme;
